module.exports = __webpack_public_path__ + "img/lev.c634b12.svg";